import formatDuration from "date-fns/formatDuration";
import { Locale as DateFnsLocale } from "date-fns";

export const humanizeMinutes = (v: number, locale: DateFnsLocale): string => {
  const hours = parseInt(v / 60 + "");
  const minutes = v % 60;

  return formatDuration(
    { minutes: minutes, hours: hours },
    { locale, format: ["hours", "minutes"], delimiter: " " }
  );
};
